import Header from "../components/Header";
import "./scss/addEtcProduct.scss";
import { rootReducer } from "../store/store";
import { useDispatch, useSelector } from "react-redux";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import Check from "../components/Check";
import { useHistory } from "react-router-dom";
import { useEffect, useState, useRef, RefObject } from "react";
import {
  AdditionRestChargeInfo,
  PromotionType,
  RestChargeInfo
} from "../types/AdditionRestChargeTypes";
import InsuranceModal from "../components/InsuranceModal";
import {
  CarInsuranceChargeInfo,
  CarInsuranceInfo
} from "../types/CarInsuranceChargeTypes";
import { useCommonUtil } from "../util/useCommonUtil";
import { product } from "../actions/authActions";
import { AlertType, alertType } from "../types/CommonType";
import AlertModal from "../components/AlertModal";
import React from "react";
import axiosInstance from "../api/axiosInstance";
import PromotionModal from "../components/PromotionModal";
type AuthState = ReturnType<typeof rootReducer>;

const AddEtcProduct: React.FC = () => {
  const {
    formatNumber,
    calculateAgeFromBirthdate,
    formatDate,
    sliceLicenseNumber,
    addHyphenToLicenseNumber,
    calculateYearsSinceIssued
  } = useCommonUtil();
  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);
  const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
  const [checkedItems, setCheckedItems] = useState<RestChargeInfo[]>([]); // 기타상품
  const [totalAddAmt, setTotalAddAmt] = useState<number>(0);
  const [, setPromotionCount] = useState<number>(0);
  const [checkedIns, setCheckedIns] = useState<CarInsuranceChargeInfo[]>([]); // 특약보험
  const [promotionInfo, setPromotionInfo] = useState<PromotionType[]>([]);
  const [, setInsuracneId] = useState<number>(
    Number(
      resInfo &&
        resInfo?.data?.carInsuranceChargeInfo &&
        resInfo?.data?.carInsuranceChargeInfo.filter(
          (e: CarInsuranceChargeInfo) =>
            e.carInsuranceInfo && e.carInsuranceInfo.insuranceType === "4000"
        )[0]?.insuranceId | 0
    )
  );
  const [, setTotalInsAmt] = useState<number>(0);

  const [detailShow, setDetailShow] = useState<boolean>(false);

  const driverInfo = useSelector((state: AuthState) => state.store.driver);

  resInfo?.data?.additionChargeInfoArray &&
    resInfo?.data?.additionChargeInfoArray.forEach((element) => {
      resInfo?.data?.additionRestChargeInfoArray &&
        resInfo?.data?.additionRestChargeInfoArray.forEach((charge) => {
          if (element.restChargeId === charge.restChargeId) {
            if(element.restChargeInfo.guestViewStatus !== "Y") {
              element.checkDisabled = true;
            } 

            if(charge.regType === "MANAGER") {
              element.regTypeString = "관리자";
            }
            if(charge.regType === "MOBILE") {
              element.regTypeString = "모바일체크인";
            }
            if(charge.regType === "KIOSK") {
              element.regTypeString = "키오스크";
            }

            element.chargeRequester = charge.chargeRequester;
            element.reservationId = String(charge.reservationId);
            element.restChargeInfo.guestViewStatus = "Y";
          }
        });
    });

  const history = useHistory();
  const dispatch = useDispatch();
  const prevProduct = useSelector((state: AuthState) => state.store.product);
  console.log("prevProduct ", prevProduct);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  console.log(resInfo);
  const scrollToTop = (scrollContainer: RefObject<HTMLDivElement>) => {
    const container = scrollContainer.current;
    if (container) {
      animateScroll(0, container.scrollTop, scrollContainer);
    }
  };

  const scrollToBottom = (scrollContainer: RefObject<HTMLDivElement>) => {
    const container = scrollContainer.current;

    if (container) {
      const maxScroll = container.scrollHeight - container.clientHeight;
      animateScroll(maxScroll, container.scrollTop, scrollContainer);
    }
  };

  const animateScroll = (
    target: number,
    current: number,
    scrollContainer: RefObject<HTMLDivElement>
  ) => {
    const step = (target - current) / 1; // 조절 가능한 부분: 더 큰 값을 사용하여 빠르게 이동
    let count = 0;

    const scrollAnimation = () => {
      count++;
      const nextScroll = current + step;
      const container = scrollContainer.current;

      if (container && count <= 10) {
        container.scrollTop = nextScroll;
        requestAnimationFrame(scrollAnimation);
      }
    };

    requestAnimationFrame(scrollAnimation);
  };

  const handleAddCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: AdditionRestChargeInfo,
    chargeRequester: number
  ) => {
    const restChargeId = item.restChargeId;
    console.log(item);
    const filteredItem: AdditionRestChargeInfo = {
      restChargeId: restChargeId,
      chargeRequester: chargeRequester,
      productName: item.productName,
      productCategory: item.productCategory,
      reservationId: resInfo?.data.reservationId || "",
      companyId: item.companyId,
      chargeBase: item.chargeBase,
      chargeVol: item.chargeVol,
      chargeValue: item.chargeValue,
      chargeCustomer: item.chargeCustomer,
      reservationSubSerial: item.reservationSubSerial,
      restChargeInfo: item.restChargeInfo,
      memo: item.memo
    };

    if (event.target.checked) {
      // 체크박스가 선택된 경우
      setCheckedItems((prevCheckedItems) => [
        ...prevCheckedItems,
        filteredItem
      ]);

      setTotalAddAmt((prevTotalAmt) => prevTotalAmt + chargeRequester);
    } else {
      // 체크박스가 선택 해제된 경우
      setCheckedItems((prevCheckedItems: any) =>
        prevCheckedItems.filter(
          (checkedItem: any) => checkedItem.restChargeId !== restChargeId
        )
      );
      setTotalAddAmt((prevTotalAmt) => prevTotalAmt - chargeRequester);
    }
  };

  const getPromotionImages = async () => {
    const promotionItems = [] as any;
    await axiosInstance()
      .post("/kiosk/getPromotionImages", {
        companyId: resInfo?.data?.companyId,
        reservationId: resInfo?.data?.reservationId
      })
      .then((res) => {
        if (res) {
          let idx = 0;
          if (resInfo?.data?.additionChargeInfoArray) {
            res.data.forEach((item: any, x: number) => {
              resInfo?.data?.additionChargeInfoArray.map((e) => {
                if (e.restChargeId === item.linkId) {
                  setPromotionCount(idx++); // 배열형 오브젝트로
                  promotionItems.push({
                    id: item.linkId,
                    fileId: item.fileId,
                    chargeRequester: e.chargeRequester
                  });
                }
              });
            });
          }
        }
        setPromotionInfo(promotionItems);
      });
  };

  const nextStep = () => {
    let ageErrorMsg = "";
    let yearErrorMsg = "";

    if (checkedIns && checkedIns.length > 0) {
      checkedIns.map((ins) => {
        driverInfo &&
          driverInfo.data &&
          driverInfo.data.map((driver) => {
            if (
              Number(
                calculateAgeFromBirthdate(formatDate(driver.birthday || ""))
              ) < Number(ins.carInsuranceInfo.minAge)
            ) {
              ageErrorMsg += `${ins.insuranceName} 보험은 ${ins.carInsuranceInfo.minAge}세부터 이용 가능합니다.(${driver.driverName}) <br/>`;
            }
            const licenseNum = sliceLicenseNumber(
              addHyphenToLicenseNumber(driver.licenseNum || "")
            );
            const licenseYear =
              calculateYearsSinceIssued(Number(licenseNum)) <
              Number(ins.carInsuranceInfo.minCareer);
            if (licenseYear) {
              yearErrorMsg += `${ins.insuranceName} 보험은 운전경력 ${ins.carInsuranceInfo.minCareer}년 이상부터 <br/> 이용 가능합니다.(${driver.driverName}) <br/>`;
            }
          });
      });
    }

    if (ageErrorMsg.length > 0) {
      setAlertInfo({
        title: "상품 확인",
        content: `${ageErrorMsg}`,
        show: true
      });
      return false;
    }
    if (yearErrorMsg.length > 0) {
      setAlertInfo({
        title: "상품 확인",
        content: `${yearErrorMsg}`,
        show: true
      });
      return false;
    }

    const req = {
      companyId: prevProduct?.data?.companyId,
      reservationId: prevProduct?.data.reservationId,
      modelId: prevProduct?.data.modelId,
      modelName: prevProduct?.data.modelName,
      addProductArr: checkedItems,
      addInsuranceArr: prevProduct?.data.addInsuranceArr
    };

    console.log("req", req);
    dispatch(product(req));

    history.push("/resFinal");
  };

  const addLineBreaks = (text: string) => {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  const renderModals = () => {
    const modals = [] as any;
    promotionInfo.map((e) => {
      modals.push(
        <PromotionModal
          id={e.id}
          fileId={e.fileId}
          price={e.chargeRequester}
          callback={promotionCallback}
          onClose={closeModal}
        />
      );
    });

    return modals;
  };

  const closeModal = (id: number) => {
    setPromotionInfo((prevPromotionInfo) =>
      prevPromotionInfo.filter((promotion) => promotion.id !== id)
    );
  };

  const promotionCallback = (id: number) => {
    resInfo?.data.additionChargeInfoArray.map((e) => {
      if (e.restChargeInfo.restChargeId === id) {
        console.log(e.productName);
        setCheckedItems((prevCheckedItems) => [
          ...prevCheckedItems,
          {
            restChargeId: e.restChargeInfo.restChargeId,
            chargeRequester: e.chargeRequester,
            productName: e.restChargeInfo.productName,
            productCategory: e.productCategory,
            reservationId: e.reservationId,
            companyId: e.companyId,
            chargeBase: e.chargeBase,
            chargeVol: e.chargeVol,
            chargeValue: e.chargeValue,
            chargeCustomer: e.chargeCustomer,
            reservationSubSerial: e.reservationSubSerial,
            restChargeInfo: e.restChargeInfo,
            memo: e.memo
          }
        ]);
        setTotalAddAmt((prevTotalAmt) => prevTotalAmt + e.chargeRequester);
      }
    });
    closeModal(id);
  };
  const handleTouchMove = (e: any) => {
    // 특정 div 영역 내에서는 터치 이벤트의 기본 동작을 막지 않음
    e.stopPropagation(); // 이벤트 전파 중단
  };

  useEffect(() => {
    setCheckedItems([]);
    setTotalAddAmt(0);
    if (
      resInfo?.data?.additionRestChargeInfoArray &&
      resInfo?.data?.additionRestChargeInfoArray.length > 0
    ) {
      resInfo.data.additionRestChargeInfoArray.map((e) => {
        if (e.reservationId) {
          setCheckedItems((prevCheckedItems) => [
            ...prevCheckedItems,
            {
              restChargeId: e.restChargeInfo.restChargeId,
              chargeRequester: e.chargeRequester,
              productName: e.restChargeInfo.productName,
              productCategory: e.productCategory,
              reservationId: e.reservationId,
              companyId: e.companyId,
              chargeBase: e.chargeBase,
              chargeVol: e.chargeVol,
              chargeValue: e.chargeValue,
              chargeCustomer: e.chargeCustomer,
              reservationSubSerial: e.reservationSubSerial,
              restChargeInfo: e.restChargeInfo,
              memo: e.memo,
              regType: e.regType
            }
          ]);
          setTotalAddAmt((prevTotalAmt) => prevTotalAmt + e.chargeRequester);
        }
      });
    }
    getPromotionImages();
    const productWrap = document.getElementById("add-product-wrap");
    if (productWrap) {
      productWrap.addEventListener("touchmove", handleTouchMove, {
        passive: false
      });
      return () => {
        productWrap.removeEventListener("touchmove", handleTouchMove);
      };
    }

    renderModals();
  }, [resInfo]);

  return (
    <>
      <Header></Header>
      {alertInfo.show && (
        <AlertModal
          onClose={() => {
            setAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}
      {renderModals()}
      <div className="product-wrap">
        <div className="product-title-wrap">기타 상품 추가하기</div>

        <div className="add-ins-wrap">
          <div className="title">
            <span>기타상품</span>
          </div>

          <div
            className="add-product-wrap"
            ref={scrollContainerRef}
            id="add-product-wrap"
          >
            {resInfo?.data?.additionChargeInfoArray.length === 0 ? (
              <p style={{ fontSize: "1.5em" }}>등록된 기타 상품이 없습니다.</p>
            ) : (
              resInfo?.data?.additionChargeInfoArray.map(
                (item, idx) =>
                  item.restChargeInfo.guestViewStatus === "Y" && (
                    <>
                      <label key={idx}>
                        <div className="product-list">
                          <div style={{ width: "45px" }}>
                            {item.checkDisabled || item.regTypeString === "관리자" || (
                              <Check
                                pre={
                                  !!checkedItems.find(
                                    (e) => e.restChargeId === item.restChargeId
                                  )
                                }
                                value={item.restChargeId}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                  handleAddCheckboxChange(event, item, item.chargeRequester)
                                }
                              ></Check>
                            )}
                          </div>

                          <div className="product-name">
                            <span style={{ marginBottom: "7px" }}>
                              {item.restChargeInfo.productName}{" "}
                              {item.regTypeString && (
                                <span style={{fontSize: "0.7em"}}>{`(${item.regTypeString}에서 추가된 상품입니다.)`}</span>
                              )}
                            </span>
                            <span className="etc">
                              {item.restChargeInfo.etc
                                ? addLineBreaks(item.restChargeInfo.etc)
                                : "설명 없음"}
                            </span>
                          </div>

                          <div className="product-price-wrap">
                            <span>{formatNumber(item.chargeRequester)}원</span>
                          </div>
                        </div>
                      </label>
                    </>
                  )
              )
            )}
          </div>
          <div
            className="arrow-wrap"
            style={{
              background: "white",
              position: "relative",
              height: "auto",
              width: "calc(100% + 0px)"
            }}
          >
            <SvgIcon
              component={KeyboardArrowUpOutlinedIcon}
              style={{
                fontSize: "5em",
                marginRight: "30px",
                color: "#e4e7ec"
              }}
              onClick={() => {
                scrollToTop(scrollContainerRef);
              }}
            ></SvgIcon>
            <SvgIcon
              component={KeyboardArrowDownOutlinedIcon}
              style={{ fontSize: "5em", color: "#3E83F1" }}
              onClick={() => {
                scrollToBottom(scrollContainerRef);
              }}
            ></SvgIcon>
          </div>
        </div>

        <div className="total-price-wrap">
          <div style={{ width: "50%", marginRight: "40px" }}>
            <div className="info-wrap">
              <span className="total-count-label">총 수량</span>
              <span className="total-count">{checkedItems.length}개</span>
            </div>

            <div className="info-wrap">
              <span className="total-count-label">추가 금액</span>
              <span className="total-count">
                {formatNumber(totalAddAmt)}원{" "}
              </span>
            </div>
          </div>
          <div className="btn-wrap" style={{ width: "50%" }}>
            <button onClick={nextStep}>다음 단계로</button>
          </div>
        </div>
        {detailShow && (
          <InsuranceModal
            detail={
              resInfo?.data?.carInsuranceChargeInfo &&
              resInfo?.data?.carInsuranceChargeInfo[0]
            }
            onClose={() => {
              setDetailShow(false);
            }}
          ></InsuranceModal>
        )}
      </div>
    </>
  );
};

export default AddEtcProduct;
